import {baseDeleteRequest} from "../base/baseDeleteRequest";

const deleteProjects = async (ids: Array<number | string>) =>
  baseDeleteRequest(`/project/`, {ids: ids});

export default deleteProjects;
